module.exports = __webpack_public_path__ + "img/bml-logo.c6342164.jpg";